import { render } from "./ProcessSignIn.vue?vue&type=template&id=4a5f76fc"
import script from "./ProcessSignIn.vue?vue&type=script&lang=js"
export * from "./ProcessSignIn.vue?vue&type=script&lang=js"

import "./ProcessSignIn.vue?vue&type=style&index=0&id=4a5f76fc&lang=css"
script.render = render

export default script